export interface KeyEventBinding {
	[keyCode: number]: (e: KeyboardEvent) => void;
}

export const KeyCode = {
	ENTER: 13,
	ESCAPE: 27,

	bind(keyEvents: KeyEventBinding) {
		return (e: KeyboardEvent) => {
			const event = keyEvents[e.keyCode];
			if (event == null) {
				return;
			}

			event(e);
		};
	},
};
